import { render, staticRenderFns } from "./RootCategories.vue?vue&type=template&id=1ceb304e&scoped=true"
import script from "./RootCategories.vue?vue&type=script&lang=js"
export * from "./RootCategories.vue?vue&type=script&lang=js"
import style0 from "./RootCategories.vue?vue&type=style&index=0&id=1ceb304e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb304e",
  null
  
)

export default component.exports